import "core-js/modules/es.symbol.description.js";
const _excluded = ["row", "id", "label", "items", "error", "isRequired"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material';
import FormErrorMessage from "./FormErrorMessage.js";
import RequiredIndicator from "./RequiredIndicator.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RadioOptions = _ref => {
  let {
      row,
      id,
      label,
      items,
      error,
      isRequired
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const renderRadios = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: items.map((item, index) => /*#__PURE__*/_jsx(FormControlLabel, {
        value: item.id,
        control: /*#__PURE__*/_jsx(Radio, {}),
        label: item.label
      }, "".concat(id, "_").concat(index)))
    });
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    error: !!error,
    children: [/*#__PURE__*/_jsxs(FormLabel, {
      id: "".concat(id, "-radio-buttons-group-label"),
      children: [/*#__PURE__*/_jsx(RequiredIndicator, {
        isRequired: isRequired
      }), label]
    }), /*#__PURE__*/_jsx(RadioGroup, _objectSpread(_objectSpread({
      row: row,
      "aria-labelledby": "".concat(id, "-radio-buttons-group-label"),
      name: "".concat(id, "-radio-buttons-group")
    }, props), {}, {
      children: renderRadios()
    })), /*#__PURE__*/_jsx(FormErrorMessage, {
      error: error
    })]
  });
};
RadioOptions.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.array,
  label: PropTypes.string,
  row: PropTypes.bool,
  error: PropTypes.object,
  isRequired: PropTypes.bool
};
export default RadioOptions;